// extracted by mini-css-extract-plugin
export var social_proof_container = "index-module--social_proof_container--SX2Mm";
export var logo_container = "index-module--logo_container--0jStw";
export var social_proof = "index-module--social_proof--5YiZV";
export var proof = "index-module--proof--iqTGz";